import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup, FormArray } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConexionesService } from 'src/app/services/conexiones.service';
import { Socket } from 'ngx-socket-io';
import { RolService } from 'src/app/services/rol.service';


@Component({
  selector: 'app-conexion',
  templateUrl: './conexion.component.html',
  styleUrls: ['./conexion.component.scss'],
})
export class ConexionComponent implements OnInit {
  form = this.fb.group({
    cantidad: [
      '',
      [Validators.required, Validators.pattern('^[0-9]*$'), Validators.max(30)],
    ],
    borrado: [0],
    id_usuarios_creador: [sessionStorage.getItem('id_usuario')],
  });

  editarConexiones:boolean=false;

  constructor(
    public dialogRef: MatDialogRef<ConexionComponent>,
    private fb: FormBuilder,
    private conexionesService: ConexionesService,
    public _snackBar: MatSnackBar,
    private socket: Socket,
    private rolService:RolService,
  ) {
    //console.log(this.rolService.permisos)
    let permisos = this.rolService.permisos;
    for(let i in this.rolService.permisos){
      permisos[i].indexOf("Actualizar Conexiones") !== -1 ? this.editarConexiones=true:null
    }
    conexionesService.getConexiones().subscribe((data:any)=>{
      let conexiones = data.payload.reverse()
      this.form.controls.cantidad.setValue(conexiones[0].cantidad)
    });
  }

  ngOnInit(): void {}

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  createConexion() {
    this.conexionesService.createConexion(this.form.value).subscribe(
      (res) => {
        //console.log(res);
        this.socket.emit("numeroDeConexionesCambiado");
        this.openSnackBar('Límite de conexiones actualizadas con éxito.', 'X');
        this.dialogRef.close();
      },
      (error) => {
        //console.log(error);
      }
    );
  }
}
